module.exports = __webpack_public_path__ + "static/media/opencvLogo.ef1485d5.png";